import { EnvironmentEnum } from '../../main/constants/environment.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';

import { SUPPORTED_TASK_TYPES } from '../types/task.types.ts';

import { mapPreviousLesson } from './previous-lesson.mapper.ts';

export const mapIsLessonImplemented = (lessonKey: number, environmentName: string): boolean => {
  if (environmentName !== (EnvironmentEnum.PRODUCTION as string)) {
    return true;
  }

  const lessonsUtil = getLessonsUtil();
  const currentLesson = lessonsUtil.getLesson({ lesson: lessonKey });
  if (!currentLesson) {
    return false;
  }

  const isCurrentLessonImplemented = lessonsUtil.hasLessonOnlyAllowedTaskTypes(currentLesson, SUPPORTED_TASK_TYPES);
  const previousLesson = mapPreviousLesson(lessonKey);

  if (!previousLesson) {
    return isCurrentLessonImplemented;
  }

  const isPreviousLessonImplemented = lessonsUtil.hasLessonOnlyAllowedTaskTypes(previousLesson, SUPPORTED_TASK_TYPES);
  return isCurrentLessonImplemented && isPreviousLessonImplemented;
};
